export default __webpack_public_path__ + "static/media/crwnclothing.fe44fb00.png";